<template>
  <div>
    <div class="">
      <div class="pull-right mb-2 mt-4" v-if="event.bookings.length">
        <small>Last ned deltakerlister: </small>
        <a
          href="#"
          @click.prevent="exportAs('csv')"
          class="btn btn-sm btn-primary mr-1"
        >
          <i class="fa fa-file-code-o"></i> CSV</a
        >
        <a
          href="#"
          @click.prevent="exportAs('xls')"
          class="btn btn-sm btn-primary mr-1"
        >
          <i class="fa fa-file-excel-o"></i> Excel</a
        >
      </div>
    </div>
    <b-table
      v-if="event.bookings.length"
      stacked="lg"
      striped
      hover
      :fields="bookingFields"
      :items="event.bookings"
    >
      <template #cell(name)="{ item }">
        {{ item.fields[0].value }}
        {{ item.fields[1].value }}
      </template>

      <template #cell(email)="{ item }">
        {{ item.fields[2].value }}
      </template>
      <template #cell(phone)="{ item }">
        {{ item.fields[3].value }}
      </template>
    </b-table>
    <p v-if="event.bookings.length === 0">
      Ingen bookinger
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { booking } from '@/api'

export default {
  props: ['event', 'selectedDate'],
  computed: {
    ...mapGetters({
      dates: 'bookings/availableDates',
    }),
  },
  data() {
    return {
      sDate: null,
      rootUrl: process.env.VUE_APP_API_URL,
      bookingFields: [
        // A column that needs custom formatting
        { key: 'name', label: 'Navn' },
        // A regular column
        { key: 'email', label: 'E-postadresse' },
        // A virtual column made up from two fields
        { key: 'phone', label: 'Telefonnummer' },
        { key: 'code', label: 'Verdibevisnummer' },
      ],
      changeParticipants: false,
      newParticipants: this.event.participants,
    };
  },
  methods: {
    async exportAs(format) {
      const response = await booking.dates.export(this.event.id, format)
      this.$bvToast.toast(`Booking date export opened in new window`, {
        title: 'Booking date exported',
        variant: 'primary',
      })

      window.open(response.data.url)
    },
  },
};
</script>
